/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { MappingProfileFieldDto } from './MappingProfileFieldDto';
import {
    MappingProfileFieldDtoFromJSON,
    MappingProfileFieldDtoFromJSONTyped,
    MappingProfileFieldDtoToJSON,
    MappingProfileFieldDtoToJSONTyped,
} from './MappingProfileFieldDto';

/**
 * 
 * @export
 * @interface MappingProfileSummaryDto
 */
export interface MappingProfileSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof MappingProfileSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MappingProfileSummaryDto
     */
    name: string | null;
    /**
     * 
     * @type {ImportType}
     * @memberof MappingProfileSummaryDto
     */
    importType?: ImportType;
    /**
     * 
     * @type {Date}
     * @memberof MappingProfileSummaryDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {{ [key: string]: Array<MappingProfileFieldDto>; }}
     * @memberof MappingProfileSummaryDto
     */
    columnMapping?: { [key: string]: Array<MappingProfileFieldDto>; } | null;
}



/**
 * Check if a given object implements the MappingProfileSummaryDto interface.
 */
export function instanceOfMappingProfileSummaryDto(value: object): value is MappingProfileSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MappingProfileSummaryDtoFromJSON(json: any): MappingProfileSummaryDto {
    return MappingProfileSummaryDtoFromJSONTyped(json, false);
}

export function MappingProfileSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappingProfileSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'columnMapping': json['columnMapping'] == null ? undefined : json['columnMapping'],
    };
}

export function MappingProfileSummaryDtoToJSON(json: any): MappingProfileSummaryDto {
    return MappingProfileSummaryDtoToJSONTyped(json, false);
}

export function MappingProfileSummaryDtoToJSONTyped(value?: MappingProfileSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'importType': ImportTypeToJSON(value['importType']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'columnMapping': value['columnMapping'],
    };
}

